import {createFileRoute} from '@tanstack/react-router';

import {MileageRatesPage} from '@/modules/admin-settings/pages/MileageRatesPage';

export const Route = createFileRoute('/_authenticated/admin/settings/mileage-rates/')({
  component: MileageRatesPage,
});
